export const SUPPORT_EMAIL = "support@ihomefinder.com";
export const SUPPORT_PHONE = "(866) 700-8855";
